module.exports = __webpack_public_path__ + "img/block-1.9874ad37.png";